module.exports = __webpack_public_path__ + "img/men1.1a1ccf3.png";